import { FeatureFlags, User } from 'Interfaces/user';

export const featureFlagEnabled = (featureFlagName: keyof FeatureFlags, user?: User): boolean => {
    return !!user?.featureFlags?.[featureFlagName];
};
